require('./accountDirectDebitsView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const InactiveAccountsError = require('components/commons/inactiveAccountsError/inactiveAccountsError');

//utlities
const { toCamelCase } = require('utilities/stringHelper');
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const infoIcon = require('assets/images/icon-info-blue.svg'); //@hardcoded: replace Icon placeholder

// @actions
const accountDirectDebitsActions = require('actions/accountDirectDebits');

// @components
const AccountDirectDebitStep3 = require('components/accounts/accountDirectDebitSteps/accountDirectDebitStep3/accountDirectDebitStep3');
const AccountDirectDebitStep2 = require('components/accounts/accountDirectDebitSteps/accountDirectDebitStep2/accountDirectDebitStep2');
const AccountDirectDebitStep1 = require('components/accounts/accountDirectDebitSteps/accountDirectDebitStep1/accountDirectDebitStep1');
const AccountDirectDebitSuccessStep = require('components/accounts/accountDirectDebitSteps/accountDirectDebitSuccessStep/accountDirectDebitSuccessStep');
const AccountDirectDebitErrorStep = require('components/accounts/accountDirectDebitSteps/accountDirectDebitErrorStep/accountDirectDebitErrorStep');
const AccountDirectDebitWaitingStep = require('components/accounts/accountDirectDebitSteps/accountDirectDebitWaitingStep/accountDirectDebitWaitingStep');
const AccountDirectDebitConfirmationStep = require('components/accounts/accountDirectDebitSteps/accountDirectDebitConfirmationStep/accountDirectDebitConfirmationStep');
const AccountDirectDebitPartialSuccess = require('components/accounts/accountDirectDebitSteps/accountDirectDebitPartialSuccess/accountDirectDebitPartialSuccess');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');

// @constants
const {
    THIRD_STEP,
} = require('constants/index');
const { BRING_DIRECT_DEBITS, WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class AccountDirectDebitView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleFinish = this.handleFinish.bind(this);

        if (!props.immFlagBasedFeatures.get(BRING_DIRECT_DEBITS)) {
            this.handleCancel();
        }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    handleCancel() {
        const { accountId } = this.props.match.params;
        this.props.history.push(`/myprofile/accounts/${accountId}/debits`);
    }

    handleFinish() {
        const { uploadFiles } = this.props;
        uploadFiles();
    }

    buildWizard() {
        const {
            accountDirectDebits,
            addFile,
            immAccounts,
            immFlagBasedFeatures,
            match: { params: { accountId } },
            removeFile,
            setAccount,
            setDescription,
            setVisibleStep,
            setWillCancel,
            validateStep
        } = this.props;

        const immAccount = immAccounts.getIn(['byId', accountId]);
        const selectedAccount = immAccounts.getIn(['byId', accountDirectDebits.get('fromAccount')]);
        const immSteps = accountDirectDebits.get('steps');
        const visibleStep = accountDirectDebits.get('visibleStep');
        const fromAccount = accountDirectDebits.get('fromAccount');
        const actions = {
            validateStep: validateStep,
            setWillCancel: setWillCancel,
            setVisibleStep: setVisibleStep,
            finish: this.handleFinish,
            cancel: this.handleCancel
        };

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
                showPreLeaveModal={true}
            >
                <WizardStep position="first" cancelButton={true}>
                    <AccountDirectDebitStep1 />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                >
                    <AccountDirectDebitStep2
                        immAccounts={immAccounts}
                        initialAccountId={immAccount.get('accountId')}
                        isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                        setAccount={setAccount}
                        fromAccount={fromAccount}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    nextButtonDisabled={immSteps.getIn([THIRD_STEP, 'filesAttached']).size === 0}
                >
                    <AccountDirectDebitStep3
                        addFile={addFile}
                        setDescription={setDescription}
                        removeFile={removeFile}
                        immStep={immSteps.get(THIRD_STEP)}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    position="last"
                    cancelButton={true}
                    immFinalButton="accountDirectDebitsView-submitButton"
                >
                    <AccountDirectDebitConfirmationStep
                        immAccount={selectedAccount || immAccount}
                    />
                </WizardStep>
            </Wizard>

        );
    }

    buildRequestInfoCard() {
        const { accountDirectDebits, immAccounts } = this.props;
        const immSteps = accountDirectDebits.get('steps');
        const attachmentsCount = immSteps.getIn([THIRD_STEP, 'filesAttached']).size;
        const visibleStep = accountDirectDebits.get('visibleStep');

        const fromAccount = accountDirectDebits.get('fromAccount');
        const originAccount = fromAccount && immAccounts.getIn(['byId', fromAccount]);
        const originAccountAlias = originAccount && (originAccount.get('alias') || toCamelCase(originAccount.get('accountType')));
        const originAccountText = `${originAccountAlias} ...${originAccount && originAccount.get('iban').substr(-4)}`;

        let requestInfoCard;
        const list = ['infoCardText1', 'infoCardText2', 'infoCardText3'];
        const elements = list.map((item, index) => {
            return (
                <li className="account-direct-debit-view__info-card-item" key={`element-${index}`}>
                    <FormattedText
                        value={`accountDirectDebitsView-${item}`}
                    />
                </li>
            );
        });

        const boxTitle = formatText('accountDirectDebitsView-requestInfoTitle');
        const boxBody = (
            <div>
                <div className="account-direct-debit-view__info-card-icon">
                    <OKIconIllustrative icon="info" product="banking" />
                </div>
                <ul className="account-direct-debit-view__info-card-list">
                    {elements}
                </ul>
            </div>
        );

        if ([2, 3].includes(visibleStep)) {
            requestInfoCard = (
                <div className="account-direct-debit-view">
                    <div className="account-direct-debit-view__info-card">
                        <ContactInfoBox
                            boxTitle={boxTitle}
                            boxBody={boxBody}
                            icon={infoIcon}
                        />
                    </div>
                </div>
            );
        } else if (visibleStep === 4) {
            requestInfoCard = (
                <div className="account-direct-debit-view">
                    <div className="account-direct-debit-view__request-info">
                        <h2 className="account-direct-debit-view__request-info-title">
                            <FormattedText value="accountDirectDebitsView-requestSummaryTitle" />
                        </h2>
                        <div className="account-direct-debit-view__request-info-body">
                            <p className="account-direct-debit-view__request-info-label">
                                <FormattedText value="accountDirectDebitsView-requestSummaryAssociatedAccount" />
                            </p>
                            <p className="account-direct-debit-view__request-info-value">
                                {originAccountText}
                            </p>
                            <p className="account-direct-debit-view__request-info-label">
                                <FormattedText value="accountDirectDebitsView-requestSummaryAttachedReceipts" />
                            </p>
                            <p className="account-direct-debit-view__request-info-value">
                                <FormattedText
                                    value="accountDirectDebitsView-requestSummaryAttachedReceiptsText"
                                    injectedStrings={[attachmentsCount]}
                                />
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
        return requestInfoCard;
    }

    render() {
        const {
            accountDirectDebits,
            immAccounts,
            match: { params: { accountId } }
        } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const changedAccount = immAccounts.getIn(['byId', accountDirectDebits.get('fromAccount')]);
        const allAccountsInactive = hasAllAccountsInactive(
            immAccounts.get('byOrder'),
            immAccounts.get('byId')
        );
        let block, bodyBlock;

        if (immAccount) {
            const alias = immAccount.get('isAliasUpdating') ? toCamelCase(immAccount.get('aliasTentative')) : toCamelCase(immAccount.get('alias'));
            const selectedAccountId = (changedAccount && changedAccount.get('accountId')) || (immAccount && immAccount.get('accountId'));
            const commonPath = '/myprofile/accounts';
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-accounts'),
                    url: commonPath
                },
                {
                    text: alias,
                    url: `${commonPath}/${accountId}/movements`
                },
                {
                    text: formatText('breadcrumb-debits'),
                    url: `${commonPath}/${accountId}/debits`
                },
                {
                    text: formatText('breadcrumb-directDebits'),
                    url: ''
                }
            ];

            if (allAccountsInactive) {
                bodyBlock = (<InactiveAccountsError
                    navigateToBackButtonText={'accounts'}
                    navigateToBackButtonURL={'accounts'}
                />);
            }
            else if (accountDirectDebits.get('isFetching')) {
                bodyBlock = (
                    <AccountDirectDebitWaitingStep />
                );
            } else if (accountDirectDebits.get('submitError')) {
                bodyBlock = (
                    <AccountDirectDebitErrorStep
                        selectedAccountId={selectedAccountId}
                    />
                );
            } else if (accountDirectDebits.get('submitSuccessful')) {
                bodyBlock = (
                    <AccountDirectDebitSuccessStep
                        selectedAccountId={selectedAccountId}
                    />
                );
            } else if (accountDirectDebits.get('submitPartialSuccess')) {
                bodyBlock = (
                    <AccountDirectDebitPartialSuccess
                        immAccount={changedAccount || immAccount}
                        filesAttached={accountDirectDebits.getIn(['steps', THIRD_STEP, 'filesAttached'])}
                    />
                );
            }
            else {
                bodyBlock = (
                    <div>
                        <div className="col-md-12 col-lg-8">
                            {this.buildWizard()}
                        </div>
                        <div className="hidden-xs hidden-sm hidden-md col-lg-4">
                            {this.buildRequestInfoCard()}
                            <CallMeBack isSmall={true} pageTitle={formatText('breadcrumb-accounts')} hasEntrance={false}/>
                        </div>
                    </div>
                );
            }
            block = (
                <div className="account-direct-debit-view">
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    finalTitle={getFinalTitle('breadcrumb-directDebits')}>
                                    <CardHeaderDetails immCard={immAccount} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                <div className="row grid-view--content-position-negative">
                                    {bodyBlock}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return block;
    }
}

AccountDirectDebitView.propTypes = {
    accountDirectDebits: PropTypes.object.isRequired,
    addFile: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    removeFile: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    setAccount: PropTypes.func,
    setDescription: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    uploadFiles: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
};

module.exports.constructor = AccountDirectDebitView;
module.exports.AccountDirectDebitView = connect(
    state => ({
        accountDirectDebits: state.accountDirectDebits,
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    addFile: accountDirectDebitsActions.addFile,
    removeFile: accountDirectDebitsActions.removeFile,
    resetState: accountDirectDebitsActions.resetState,
    setDescription: accountDirectDebitsActions.setDescription,
    setVisibleStep: accountDirectDebitsActions.setVisibleStep,
    setWillCancel: accountDirectDebitsActions.setWillCancel,
    setAccount: accountDirectDebitsActions.setAccount,
    uploadFiles: accountDirectDebitsActions.uploadFiles,
    validateStep: accountDirectDebitsActions.validateStep
})(withRouter(AccountDirectDebitView));
